import React, { useState, useEffect } from 'react';
import { Clock, User, X, FileText } from 'lucide-react';
import axiosInstance from '../../utils/axiosConfig';
import { useNavigate } from 'react-router-dom';
import { formatFecha, formatHora } from '../gh';

// Cuándo es el permiso, en corto
const cuando = (p) => {
    if (p.modalidad === 'dia_completo') {
        return p.fecha_fin && p.fecha_fin !== p.fecha_inicio
            ? `${formatFecha(p.fecha_inicio)} al ${formatFecha(p.fecha_fin)}`
            : formatFecha(p.fecha_inicio);
    }
    return `${formatFecha(p.fecha)}, ${formatHora(p.hora_inicio)}`;
};

const PermisosPendientesWidget = () => {
    const [data, setData] = useState(null);
    const [loading, setLoading] = useState(true);
    const [dismissed, setDismissed] = useState(false);
    const navigate = useNavigate();

    useEffect(() => {
        const today = new Date().toDateString();
        const key = `widget_dismiss_permisos_${today}`;
        if (localStorage.getItem(key)) setDismissed(true);
    }, []);

    useEffect(() => {
        fetchPendientes();
    }, []);

    // Trae lo que espera al usuario: como jefe y, si es de GH, la bandeja de Gestión Humana
    const fetchPendientes = async () => {
        try {
            const res = await axiosInstance.get('/api/permisos/pendientes-supervisor');
            if (res.data.total > 0) setData(res.data);
        } catch (err) {
            console.error('Error cargando permisos pendientes:', err);
        } finally {
            setLoading(false);
        }
    };

    const handleDismiss = () => {
        if (window.confirm('¿Ocultar este aviso por hoy?')) {
            const today = new Date().toDateString();
            localStorage.setItem(`widget_dismiss_permisos_${today}`, 'true');
            setDismissed(true);
        }
    };

    if (loading || !data || dismissed) return null;

    return (
        <section className="relative rounded-2xl overflow-hidden border border-gray-200 bg-white group">
            <button
                onClick={handleDismiss}
                className="absolute top-3 right-3 z-20 w-7 h-7 rounded-full text-gray-400 hover:text-gray-600 hover:bg-gray-100 flex items-center justify-center opacity-0 group-hover:opacity-100 focus-visible:opacity-100 transition-all"
                title="Ocultar por hoy"
                aria-label="Ocultar por hoy"
            >
                <X size={14} />
            </button>

            <div className="px-5 py-4 border-b border-gray-100 flex items-center gap-3">
                <div className="w-10 h-10 rounded-xl bg-sura-blue text-white flex items-center justify-center">
                    <Clock size={20} />
                </div>
                <div>
                    <h3 className="font-semibold text-gray-900">Permisos por aprobar</h3>
                    <p className="text-gray-500 text-sm">
                        {data.total} {data.total === 1 ? 'permiso espera' : 'permisos esperan'} tu decisión
                    </p>
                </div>
            </div>

            <div className="p-4 space-y-2">
                {data.pendientes.slice(0, 3).map((p) => (
                    <div key={p.id} className="rounded-xl px-3 py-2.5 border border-gray-100">
                        <div className="flex items-center justify-between gap-2">
                            <div className="flex items-center gap-2 min-w-0">
                                <User size={14} className="text-gray-400 flex-shrink-0" />
                                <span className="text-sm font-medium text-gray-900 truncate">{p.empleado_nombre}</span>
                            </div>
                            {p.aprueba_gh && (
                                <span className="text-xs text-sura-blue bg-sura-blue/5 px-2 py-0.5 rounded-full font-medium flex-shrink-0">
                                    Gestión Humana
                                </span>
                            )}
                        </div>
                        <div className="flex items-center gap-2 mt-1 text-xs text-gray-500">
                            <FileText size={12} className="flex-shrink-0" />
                            <span className="truncate">{p.tipo_display}, {cuando(p)}</span>
                        </div>
                    </div>
                ))}

                {data.total > 3 && (
                    <p className="text-xs text-gray-500 text-center">
                        Y {data.total - 3} más
                    </p>
                )}

                <button
                    onClick={() => navigate('/solicitud-permisos')}
                    className="w-full py-2.5 rounded-xl bg-sura-blue text-white text-sm font-medium hover:bg-sura-blue-dark transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-sura-blue focus-visible:ring-offset-2"
                >
                    Revisar permisos
                </button>
            </div>
        </section>
    );
};

export default PermisosPendientesWidget;
